import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import { ReportConfigurationDataModel } from "../../services/reporting-data-service/Models";
import ReportingDataService from "../../services/reporting-data-service/ReportingDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "../drcx/Keys";

export type UseReportConfigurationDataQueryParameters = {
    groupID: number;
    isMyReports?: boolean;
    includeInaccessibleReports?: boolean;
    includeChildGroups?: boolean;
} & BaseUseQueryParameters<ReportConfigurationDataModel>;

export function useReportConfigurationData({
    groupID,
    isMyReports,
    includeInaccessibleReports,
    includeChildGroups,
    enabled,
    onError,
    onSuccess
}: UseReportConfigurationDataQueryParameters) {
    return useQuery<ReportConfigurationDataModel | undefined, RestError>(
        keys.configurationList(
            groupID,
            isMyReports,
            includeInaccessibleReports,
            includeChildGroups,
        ),
        ({ signal }) => {
            return ReportingDataService.getConfigurations(
                groupID,
                isMyReports,
                includeInaccessibleReports,
                includeChildGroups,
                signal
            );
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess,
        }
    );
}
